import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constant/Constant';
import LogoutConstant from '../../MainFrame/constants/Constants';
import restClient from '../../MainFrame/action/APIClient';
import { message } from 'antd';

var AddIntegrationAction = function () {

}


AddIntegrationAction.prototype = {

	editintegration: function (data) {

		restClient.integrationsupdate(data, function (error, response) {
			if (error) {
				message.error(error.data.message)
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				}
				// AppDispatcher.dispatch({
				// 	actionType: Constant.EDIT_INTEGRATION_CONTROL,
				// 	data: error
				// });
			} else {
				// console.log('AddIntegrationAction : ', response)
				response['status']=200;
				AppDispatcher.dispatch({
					actionType: Constant.EDIT_INTEGRATION_CONTROL,
					data: response
				});
			}
		})
	}
}

export default new AddIntegrationAction();